import React from "react";
import Styles from "./Card.module.scss";

const CardStack = ({children}: React.HTMLAttributes<HTMLElement>) => {
	return <div className={Styles.stack}>{children}</div>
}

export default CardStack;
